/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {Link, useParams, useLocation} from 'react-router-dom';
import {gql, useLazyQuery} from '@apollo/client';
import ReactDiffViewer from 'react-diff-viewer-continued';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import PageSpinner from "../global/pageSpinner";
import {omit} from "lodash";
import {removeLastNthParamFrmUrl } from '../../utils';

const VA_HISTORY_DIFF_QUERY = gql`
query VerificationActivityHistoryDiff($vaHisId:String, $parentId: String){
    verificationActivityHistoryDiff(_id:$vaHisId, parentId: $parentId){
        _id
        dh_id {
            _id
        }
        va_short_desc
        va_long_desc
        va_type
        va_onshore_offshore
        va_freq
        va_baseline_sample
        va_class
        va_legislation
        va_child_id
        va_added_date
        va_added_id
        va_archived
        va_status
        history_parent_record_id
        history_modifying_user_id {
            _id
            user_fname
            user_lname
            user_email
            user_job_title
            user_office_tel
            user_mobile
            user_profile_image
        }
        history_modified_date
        history_modified_date_timestamp
    }
}`;

function VerificationActivityHistoryDiff(props) {
    const [vaHistDiff, setVaHistDiff] = useState([]);
    const [user, setUser] = useState({});
    const { hisId = "", parentId = "" } = useParams();

    const location = useLocation();
    const { pathname: url = ""} = location ? location : {};

    const [verificationActivityHistoryDiff, { loading, error, data: vaHistDiffData }] = useLazyQuery(VA_HISTORY_DIFF_QUERY);

    useEffect(() => {
        if (hisId !== "" && parentId !== "") {
            verificationActivityHistoryDiff({ variables: { vaHisId: hisId, parentId: parentId }, errorPolicy: 'all' });
        }
    }, []);

    useEffect(() => {
        if (vaHistDiffData && vaHistDiffData.verificationActivityHistoryDiff) {
            setVaHistDiff(vaHistDiffData.verificationActivityHistoryDiff);
            let user = vaHistDiffData.verificationActivityHistoryDiff.find(his => his.history_modifying_user_id !== null);
            if (user) {
                setUser(user.history_modifying_user_id);
            }
        }
    }, [vaHistDiffData]);

    if (loading) {
        return (
            <PageSpinner />
        )
    }

    if (error) {
        return (
            <span>Something went wrong retrieving the diff data</span>
        )
    }

    return (
        <div className="w-full px-8 pb-8">

            <div className="mb-6 pb-3 border-b-2 border-gray-200">
                <h1 className="mb-3 text-blue-900 font-sans text-2xl font-bold uppercase">Verification Activity History Change</h1>
            </div>
            <Link to={`${removeLastNthParamFrmUrl(url, 3)}/histories`} className="mr-2 button-red"><FontAwesomeIcon
                icon={['fas', 'angle-left']} /> Back</Link>

            <h3 className="mt-4 text-blue-900 font-sans text-lg font-bold uppercase">Modifying User</h3>

            <img src={user.user_profile_image && user.user_profile_image} alt={`${user.user_fname ? user.user_fname : ''}  ${user.user_lname ? user.user_lname : ''}`}
                className="mt-6 rounded-full w-24 max-w-full h-auto align-middle" />

            <div className="w-full lg:w-1/2">

                <div className="my-6 pb-6 border-b-2 border-gray-200">
                    <h2 className="font-bold text-2xl text-blue-900">{user.user_fname && user.user_fname} {user.user_lname && user.user_lname}</h2>
                    <h3 className="mb-3 font-bold text-red-900">{user.user_job_title && user.user_job_title}</h3>

                    <p>Email: {user.user_email && user.user_email}</p>
                    <p>Tel: {user.user_office_tel && user.user_office_tel}</p>
                    <p>Mobile: {user.user_mobile && user.user_mobile}</p>
                </div>
            </div>

            <div className="mt-6">
                <ReactDiffViewer
                    oldValue={JSON.stringify(omit(vaHistDiff[1], ['__typename', 'history_modifying_user_id', 'dh_id']), null, 2)}
                    newValue={JSON.stringify(omit(vaHistDiff[0], ['__typename', 'history_modifying_user_id', 'dh_id']), null, 2)}
                    splitView={true}
                />
            </div>

        </div>
    );
}

export default VerificationActivityHistoryDiff;
